import { useState, useEffect, useRef } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import './GalleryGrid.css';

function GalleryGrid({ images }) {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const trackRef = useRef(null);

  const openLightbox = (index) => {
    setLightboxIndex(index % images.length);
    setLightboxOpen(true);
  };

  // Duplicate images for seamless infinite loop
  const loopImages = [...images, ...images];

  const slides = images.map((img) => ({ src: img.src, alt: img.alt }));

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    if (isPaused) {
      track.style.animationPlayState = 'paused';
    } else {
      track.style.animationPlayState = 'running';
    }
  }, [isPaused]);

  return (
    <>
      <div
        className="gallery-carousel"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div className="gallery-carousel__track" ref={trackRef}>
          {loopImages.map((img, index) => (
            <div
              key={index}
              className="gallery-carousel__slide"
              onClick={() => openLightbox(index)}
            >
              <img src={img.src} alt={img.alt} loading="lazy" />
              <div className="gallery-carousel__overlay">
                <div className="gallery-carousel__overlay-content">
                  <span className="gallery-carousel__overlay-title">{img.alt}</span>
                  <span className="gallery-carousel__overlay-cta">View</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={slides}
        index={lightboxIndex}
      />
    </>
  );
}

export default GalleryGrid;
